(function () {
    angular.module('tradersyard').component('tyInvitationsScreenInviteViaEmail', {
        bindings: {
            entryType: '@',
            entryId: '@',
        },
        controller: InvitationsScreenInviteViaEmailCtrl,
        // language=HTML
        template: `
            <table class="invitation-screen-invite-via-email table">
                <tbody>
                <tr ng-repeat="e in $ctrl.emails track by $index">
                    <td style="width: 1em">#{{$index + 1}}</td>
                    <td style="width: 38em">
                        <input type="email" ng-model="$ctrl.emails[$index].value"
                               class="form-control"
                               ng-disabled="$ctrl.isLoading">
                    </td>
                    <td>
                        <button ng-click="$ctrl.removeItem($index)" class="btn btn-sm btn-default"
                                ng-show="$ctrl.emails.length > 1"
                                ng-disabled="$ctrl.isLoading">Remove
                        </button>
                    </td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <td colspan="3" class="text-center">
                        <button ng-click="$ctrl.addMore()" class="btn btn-sm btn-default" ng-disabled="$ctrl.isLoading">
                            Add another email
                        </button>
                    </td>
                </tr>
                </tfoot>
            </table>
            <div class="text-center">
                <button ng-click="$ctrl.sendInvitations()" class="btn btn-primary btn-lg" ng-disabled="$ctrl.isLoading">
                    Send email invitations
                    <span class="fa fa-spin fa-spinner" ng-show="$ctrl.isLoading"></span>
                </button>
            </div>

            <div class="text-center" ng-switch="$ctrl.feedback[0]" role="alert">
                <h4 class="text-danger" ng-switch-when="error" ng-bind="$ctrl.feedback[1]"></h4>
                <h4 class="text-success" ng-switch-when="success" ng-bind="$ctrl.feedback[1]"></h4>
            </div>
        `,
    });

    InvitationsScreenInviteViaEmailCtrl.$inject = ['graph-invite-factory', '$scope'];

    function InvitationsScreenInviteViaEmailCtrl(inviteApiFactory, $scope) {
        const ctrl = this;

        let inviteApi;

        ctrl.isLoading = false;

        /**
         * @type {["error"|"success", string]}
         */
        ctrl.feedback = ['', ''];

        /**
         * @type {[{value: string}]}
         */
        ctrl.emails = _defaultEmails();

        ctrl.$onInit = $onInit;
        ctrl.$onChanges = $onChanges;
        ctrl.addMore = addMore;
        ctrl.removeItem = removeItem;
        ctrl.sendInvitations = sendInvitations;

        function $onInit() {
            $onChanges();
        }

        function $onChanges() {
            inviteApi = inviteApiFactory.entry(ctrl.entryType, ctrl.entryId);
        }

        function addMore() {
            ctrl.emails.push({ value: '' });
        }

        function removeItem(idx) {
            ctrl.emails.splice(idx, 1);
        }

        async function sendInvitations() {
            ctrl.isLoading = true;
            const emails = ctrl.emails.map((el) => el.value);

            try {
                await inviteApi.viaEmail({ emails });
                ctrl.emails = _defaultEmails();
                ctrl.feedback = ['success', 'Invitations sent.'];
            } catch (e) {
                ctrl.feedback = ['error', 'Invitations could not be sent.'];
            } finally {
                ctrl.isLoading = false;
                $scope.$digest();
            }
        }

        function _defaultEmails() {
            return [
                {
                    value: '',
                },
            ];
        }
    }
})();
